<template>
  <div id="app">

    <md-dialog :md-active.sync="blockDialogNPS">
      <md-dialog-title>
        <md-button class="md-icon-button close-button" @click="blockDialogNPS=false" id="mod_btnClose">
          <md-icon>clear</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content class="alert-nps">
        <img class="img-feedback" src="@/assets/svg/nps-logo.svg">

        <span class="md-body-2">{{$t('opinionNPS')}}</span>
        <span class="md-caption">{{$t('rateSoFar')}}</span>

        <div class="nps-button">
          <img @click='sendFeedBack(false)' class="feedback" src="@/assets/svg/negative-nps.svg">
          <img @click='sendFeedBack(true)' class="feedback" src="@/assets/svg/positive-nps.svg">
        </div>
      </md-dialog-content>
    </md-dialog>

    <md-dialog :md-active.sync="blockDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">
      <md-dialog-title>{{ $t('corporateNotice') }}</md-dialog-title>

      <md-dialog-content class="corporate-notice">{{
        corporateNotice.message
      }}
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised md-accent-container" @click="blockDialog = false">{{ $t('ok') }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="blockDialogTerms" :md-click-outside-to-close="false" :md-close-on-esc="false">
      <md-dialog-title>{{ $t('accept') }}</md-dialog-title>

      <md-dialog-content class="alert-policy">
        <div class="block-accept">
          <span class="md-subheading">{{$t('privacyPolicy')}}</span>
          <span class="text-area-policy-and-terms" v-html="privacyPolicy"></span>
          <md-checkbox v-model="privacyPolicyAccept">{{$t('acceptPrivacyPolicy')}}</md-checkbox>
        </div>
        <md-divider class="divider"/>
        <div class="block-accept">
          <span class="md-subheading">{{$t('termsOfUse')}}</span>
          <span class="text-area-policy-and-terms" v-html="termsOfUse"></span>
          <md-checkbox v-model="termsOfUseAccept">{{$t('acceptTermsOfUse')}}</md-checkbox>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised md-accent-container" :disabled="!(termsOfUseAccept && privacyPolicyAccept)" @click="agreeWithTheTerms">{{ $t('agree') }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar md-position="center" :md-duration="Infinity" :md-active="message !== ''">
      <span class="erro-message">{{ translated ? message : $t(message, messageValue) }}</span>
      <md-button class="snack-button md-primary-container" @click="hideMessage()">{{ $t('close') }}</md-button>
    </md-snackbar>

    <div v-show="loading" class="loading-full lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>


    <div v-show="loading" class="overlay"></div>

    <router-view v-show="!loading" v-if="showFullScreen"></router-view>



    <admin-menu v-show="!loading" v-else>
    </admin-menu>


  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AdminMenu from './components/AdminMenu'
import EventBus from '@/eventbus/index.js'
import materialYou from '@/utils/materialYou.js'

export default {
  name: 'app',
  components: {
    AdminMenu
  },
  data: () => ({
    privacyPolicyAccept: false,
    termsOfUseAccept: false,
  }),
  computed: {
    ...mapState('Global', ['message', 'messageValue', 'loading', 'initialSettings', 'message', 'translated']),
    ...mapState('Alert', ['privacyPolicy', 'termsOfUse']),
    showFullScreen() {
      return this.$route.meta.fullScreen || window.location.pathname.includes('settingsInitial')
    },
    blockDialog: {
      get() {
        return this.$store.getters['Global/blockDialog']
      },
      set(value) {
        this.$store.dispatch('Global/setBlockDialog', value)
      }
    },
    blockDialogTerms: {
      get() {
        return this.$store.getters['Global/blockDialogTerms']
      },
      set(value) {
        this.$store.dispatch('Global/setBlockDialogTerms', value)
      }
    },
    blockDialogNPS: {
      get() {
        return this.$store.getters['Global/blockDialogNPS']
      },
      set(value) {
        this.$store.dispatch('Global/setBlockDialogNPS', value)
      }
    },
    corporateNotice() {
      if (this.blockDialog) {
        const favoriteSiteConfig = this.initialSettings.sites && this.initialSettings.user.workspace.favoriteSiteId ?
          this.initialSettings.sites.find(site => site.id == this.initialSettings.user.workspace.favoriteSiteId) : null

        const alert = {
          message: favoriteSiteConfig != null && favoriteSiteConfig.corporateNotice.message ? favoriteSiteConfig.corporateNotice.message : this.initialSettings.corporateNotice.message
        }
        
        return alert
      }

      return {}
    },
  },
  created() {
    EventBus.subscribe(
      "setClient",
      item => this.setClient(item)
    )

    EventBus.subscribe(
      "showLoading",
      () => this.showLoading()
    )

    EventBus.subscribe(
      "hideLoading",
      () => this.hideLoading()
    )

    EventBus.subscribe(
        "setMessage",
        value => this.showMessage(value)
    )

    EventBus.subscribe(
      "getInitialSettings",
      () => {
        this.setInitialSettingsLoaded(false)
        this.getInitialSettings()
      }
    )
    EventBus.subscribe(
        "openNPS",
        () => {
          this.blockDialogNPS = true
        }
    )

    this.$store.dispatch('Global/setWindowWidth', window.innerWidth)
    let that = this
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        that.$store.dispatch('Global/setWindowWidth', window.innerWidth)
      })
    })
  },
  methods: {
    ...mapActions('Alert', ['sendAgreeTerms', 'sendNPSFeedback']),
    ...mapActions('Client', ['setClient']),
    ...mapActions('Global', ['showLoading', 'hideLoading', 'getInitialSettings', 'resetColor', 'showMessage', 'hideMessage', 'setInitialSettingsLoaded']),
    changeColor() {
      if (!this.initialSettings.applicationColor || !this.initialSettings.applicationColor.primary || !this.initialSettings.applicationColor.accent) {
        this.resetColor()
      } else {
        let colorPrimary = this.initialSettings.applicationColor.primary
        let colorAccent = this.initialSettings.applicationColor.accent


        let colorScheme = materialYou.getColorDesignJsonByHex(colorPrimary, colorAccent)
        document.documentElement.style.setProperty("--md-theme-default-primary", colorScheme.schemes.light.primary)
        document.documentElement.style.setProperty("--md-theme-default-primary-container", colorScheme.schemes.light.primaryContainer)
        document.documentElement.style.setProperty("--md-theme-default-on-primary-container", colorScheme.schemes.light.onPrimaryContainer)
        document.documentElement.style.setProperty("--md-theme-default-primary-on-background", colorScheme.schemes.light.primary)
        document.documentElement.style.setProperty("--md-theme-default-accent", colorScheme.schemes.light.secondary)
        document.documentElement.style.setProperty("--md-theme-default-accent-container", colorScheme.schemes.light.secondaryContainer)
        document.documentElement.style.setProperty("--md-theme-default-on-accent-container", colorScheme.schemes.light.onSecondaryContainer)
        document.documentElement.style.setProperty("--md-theme-default-accent-on-", this.addAlpha(colorScheme.schemes.light.secondaryContainer, 0.38))
        document.documentElement.style.setProperty("--md-theme-default-highlight", "#F2F0F4")
        document.documentElement.style.setProperty("--md-theme-default-accent-on-background", colorScheme.schemes.light.secondary)
        if (this.shouldUseWhiteText(colorScheme.schemes.light.primary)) {
          document.documentElement.style.setProperty("--md-theme-default-text-primary-on-primary", "white")
        } else {
          document.documentElement.style.setProperty("--md-theme-default-text-primary-on-primary", "black")
        }
        if (this.shouldUseWhiteText(colorScheme.schemes.light.secondary)) {
          document.documentElement.style.setProperty("--md-theme-default-text-primary-on-accent", "white")
        } else {
          document.documentElement.style.setProperty("--md-theme-default-text-primary-on-accent", "black")
        }
      }
    },
    shouldUseWhiteText(bgColor) {
      var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor
      var r = parseInt(color.substring(0, 2), 16) // hexToR
      var g = parseInt(color.substring(2, 4), 16) // hexToG
      var b = parseInt(color.substring(4, 6), 16) // hexToB
      return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 150) ?
        false : true
    },
    addAlpha(color, opacity) {
      // coerce values so ti is between 0 and 1.
      var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
      return color + _opacity.toString(16).toUpperCase()
    },
    agreeWithTheTerms(){
      this.sendAgreeTerms().then(()=>{
        this.blockDialogTerms = false
      })
    },
    sendFeedBack(status){
      this.sendNPSFeedback(status).then(()=>{
        this.blockDialogNPS = false
      })
    }
  },
  watch: {
    initialSettings: {
      handler: function () {
        this.changeColor()
      },
      deep: true
    },
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'WorkSans';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: absolute;
  height: 100vh;
  width: 100vw;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.corporate-notice {
  white-space: pre-wrap;
}

.alert-policy{
  display: flex;
  flex-direction: column;
}

.erro-message{
  width: 404px;
}

.text-area-policy-and-terms{
  height: 15vh;
  overflow-y: auto;
}

.divider {
  width:100%;
  display: flex;
  align-self: center;
  margin-bottom: 10px!important;
}

.block-accept{
  display: flex;
  flex-direction: column;
  span{
    margin-bottom: 16px;
  }
}

.alert-nps{
  display: flex;
  flex-direction: column;
  align-items: center;
  .img-feedback{
    width: 340px;
  }
  .nps-button{
    display: flex;
    align-items: center;
    justify-content: center;
    .feedback {
      width: 64px;
      margin: 16px;

      &:hover {
        filter: brightness(70%);
      }
    }

  }
}

</style>
